import React, { Fragment , useState } from 'react';
import Error from './error';




const Paciente =({paciente})=>{

    const [error, guardarerror]= useState(false);


    if(paciente.length ===0)  {
        return null
    }
    function refreshPage(){ window.location.reload(); } 
    return(
            <Fragment>  
                <div className="my-15">
                    <h3><p className="text-info">Informacion del Paciente</p></h3>
                    <h6>Codigo del Paciente: <strong>{paciente.id}</strong> </h6>
                    <h6>Nombre del Paciente:  <strong>{paciente.nombre} {paciente.apellido}</strong></h6>
                    <h6>DNI: <strong>{paciente.numeroIdentificacion}</strong>  </h6>
                    <h6>Email:<strong>{paciente.email}</strong>   </h6>
                
                </div>
            </Fragment>

        );
 
};

export default Paciente;